module.exports = __webpack_public_path__ + "img/mes-copy.f6a71e12.png";